export type AdminUsersRedirectMode = 'list' | 'new' | 'edit';

// FLOW[46035]: ведёт сразу в секцию «Пользователи» единого центра настроек
// (раньше — /v2/admin?tab=users; тот путь тоже жив через V2AdminSettingsRedirect).
export function buildAdminUsersRedirectPath(
  mode: AdminUsersRedirectMode,
  userId?: string | null,
  search?: string | null
) {
  const params = new URLSearchParams(search || undefined);
  params.delete('tab');
  if (mode === 'new') {
    params.set('create', 'user');
  }
  if (mode === 'edit' && userId) {
    params.set('userId', userId);
    params.set('intent', 'access');
  }
  const qs = params.toString();
  return `/v2/settings/users${qs ? `?${qs}` : ''}`;
}
